import * as R from 'ramda'
import { formatMoneyWithThousandSeparator } from './helper'


export const compileTreatmentByOrder = (monthList) => {
    const table = []
    table.push(addTreatmentOrders(monthList))
    table.push(addTreatmentAveragePrice(monthList))
    table.push(addTreatmentGrossPrice(monthList))
    table.push(addTreatmentNetIncludingMedicalPrice(monthList))
    table.push(addMedicalFees(monthList))
    table.push(addMedicalNetTreatment(monthList))
    return table
}


const addTreatmentOrders = (monthList) => {
    const result = []
    result.push('Treatments ordered (#)')
    R.forEach(month => {
        result.push(month.treatmentIncomingOrder_count)
    }, monthList)
    return result
}

//
const addTreatmentAveragePrice = (monthList) => {
    const result = []
    result.push('Treatment - Average Selling Price (gross, incl medical fee, €)')
    R.forEach(month => {
        const amount = (month.treatmentIncomingOrder_brut + (20000 * month.treatmentIncomingOrder_count)) / month.treatmentIncomingOrder_count
        result.push(formatMoneyWithThousandSeparator(amount))
    }, monthList)
    return result
}

const addTreatmentGrossPrice = (monthList) => {
    const result = []
    result.push('Treatments - Gross Price')
    R.forEach(month => {
        result.push(formatMoneyWithThousandSeparator(month.treatmentIncomingOrder_brut))
    }, monthList)
    return result
}

//
const addTreatmentNetIncludingMedicalPrice = (monthList) => {
    const result = []
    result.push('Treatments ordered (incl medical fee, net)')
    R.forEach(month => {
        const amount = month.treatmentIncomingOrder_net + (20000 * month.treatmentIncomingOrder_count)
        result.push(formatMoneyWithThousandSeparator(amount))
    }, monthList)
    return result
}


const addMedicalFees = (monthList) => {
    const result = []
    result.push('Medical fees')
    R.forEach(month => {
        const amount = (20000 * month.treatmentIncomingOrder_count)
        result.push(formatMoneyWithThousandSeparator(amount))
    }, monthList)
    return result
}

// =  (€)
const addMedicalNetTreatment = (monthList) => {
    const result = []
    result.push('Net Aligner Value')
    R.forEach(month => {
        result.push(formatMoneyWithThousandSeparator(month.treatmentIncomingOrder_net))
    }, monthList)
    return result
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/basis/treatment-by-order.js